/**
 * @readonly
 * @enum {string}
 */
export const CameraViewsTypes = {
    FRONT: 'FRONT',
    DRIVER: 'DRIVER',
    AUXILIARY: 'AUXILIARY'
}
